// extracted by mini-css-extract-plugin
export var calendarView = "_l2-0";